// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/transfer/style/index.less
// module id = 1148
// module chunks = 1